import { AlertCircle, AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

interface DialerCampaign {
  isStarted: boolean
  isSyncInProgress?: boolean
  hasCallerIds: boolean
  hasActiveListsWithLeads: boolean
  instancesOnline?: boolean
}

interface DialerIssuesNotificationProps {
  campaign: DialerCampaign
}

export function DialerIssuesNotification({ campaign }: DialerIssuesNotificationProps) {
  const issues: { type: 'error' | 'warning'; title: string; message: string }[] = []

  // Check if campaign is started but has issues
  if (campaign.isStarted) {
    if (!campaign.hasCallerIds) {
      issues.push({
        type: 'error',
        title: 'No Caller IDs',
        message: 'No caller IDs are assigned to this campaign. Calls cannot be made without caller IDs.',
      })
    }

    if (!campaign.hasActiveListsWithLeads) {
      issues.push({
        type: 'warning',
        title: 'No Active Lists',
        message: 'No contact lists with leads are active. Enable a list with leads to start dialing.',
      })
    }

    if (campaign.instancesOnline === false) {
      issues.push({
        type: 'error',
        title: 'Instances Offline',
        message: 'Dialer instances are offline. Contact support to resolve this issue.',
      })
    }
  }

  if (campaign.isSyncInProgress) {
    issues.push({
      type: 'warning',
      title: 'Sync In Progress',
      message: 'Lead synchronization is in progress. Some metrics may be temporarily inaccurate.',
    })
  }

  if (issues.length === 0) return null

  return (
    <div className="space-y-2">
      {issues.map((issue, index) => (
        <Alert key={index} variant={issue.type === 'error' ? 'destructive' : 'default'}>
          {issue.type === 'error' ? (
            <AlertCircle className="h-4 w-4" />
          ) : (
            <AlertTriangle className="h-4 w-4" />
          )}
          <AlertTitle>{issue.title}</AlertTitle>
          <AlertDescription>{issue.message}</AlertDescription>
        </Alert>
      ))}
    </div>
  )
}
